import V from 'voca';
import form from './config/form';
import collection from './config/collection';
import multiSelect from './config/multi_select';
import componentMapping from './config/component_mapping';
import dashboard from './config/dashboard';
import base from './config/base';

export default {
    ...base,
    dashboard,
    form,
    collection,
    multiSelect,
    componentMapping,
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config.js